import { ERROR_MESSAGE_FOR_PAGE_VALIDATION } from '@common/middleware/errorMessages';
import {
  toggleCampaignAdvertisingMedium,
  toggleCampaignDistributionChannel,
  updateCampaignAdvertisingMediumDescription,
  updateGiftDistributionChannelDescription,
  validateProjectDraftFailure
} from '@console/actions/actions';
import type {
  AppThunkAction,
  AppThunkDispatch
} from '@console/actions/thunkType';
import { validateGiftDistributionThunk } from '@console/actions/thunks/validateProjectDraft/validateGiftDistribution';
import { getActiveStep } from '@console/common/getActiveStep';
import CampaignOverview from '@console/components/projectDraft/GiftDistribution';
import type { AppState } from '@console/reducers';
import { connect } from 'react-redux';
import type { NavigateFunction } from 'react-router';

const handleStepNextFromParent =
  (navigate: NavigateFunction): AppThunkAction<void> =>
  async dispatch =>
    dispatch(validateGiftDistributionThunk())
      .then(() => {
        const { parentStep, childStep } = getActiveStep();
        navigate(
          `${location.pathname}?parentStep=${
            parentStep + 1
          }&childStep=${childStep}`
        );
      })
      .catch(() => {
        dispatch(
          validateProjectDraftFailure(ERROR_MESSAGE_FOR_PAGE_VALIDATION)
        );
      });

const mapStateToProps = (state: AppState) => ({
  campaignGiftDistributionChannels:
    state.selectedProjectDraft.projectJson.campaignGiftDistributionChannels,
  giftDistributionChannelCategories: state.giftDistributionChannelCategories,
  campaignGiftDistributionChannelDescriptions:
    state.selectedProjectDraft.projectJson
      .campaignGiftDistributionChannelDescriptions,
  advertisingMedia: state.advertisingMedia,
  campaignAdvertisingMedia:
    state.selectedProjectDraft.projectJson.campaignAdvertisingMedia,
  errors: state.errors
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  onChangeCampaignGiftDistributionChannel: (urlCode: string) =>
    dispatch(toggleCampaignDistributionChannel(urlCode)),
  onChangeGiftDistributionChannelDescription: (
    event: GenericChangeEvent<string>,
    urlCode: string
  ) =>
    dispatch(
      updateGiftDistributionChannelDescription(urlCode, event.target.value)
    ),
  onChangeCampaignAdvertisingMedium: (urlCode: string) =>
    dispatch(toggleCampaignAdvertisingMedium(urlCode)),
  onChangeCampaignAdvertisingMediumDescription: (
    event: GenericChangeEvent<string>,
    urlCode: string
  ) =>
    dispatch(
      updateCampaignAdvertisingMediumDescription(urlCode, event.target.value)
    ),
  handleStepNextFromParent: (navigate: NavigateFunction) =>
    dispatch(handleStepNextFromParent(navigate))
});

export type GiftDistributionPropsMappedFromState = ReturnType<
  typeof mapStateToProps
>;
export type GiftDistributionPropsMappedFromDispatch = ReturnType<
  typeof mapDispatchToProps
>;

export default connect(mapStateToProps, mapDispatchToProps)(CampaignOverview);
